<template>
    <alert-modal
        :title="title"
        :superTitle="$t('OOS_WARNING_SUPER')"
        :primaryCTAText="$t('ACTION_OKAY')"
        @close="close"
        @cancel="close"
        @confirm="close"
        @overlayClick="close"
    >
        <div class="cz2__modal-popup__copy">
            {{ bodyCopy }}

            <div class="cz2__oos-icon" />
        </div>
    </alert-modal>
</template>

<style lang="scss">
    .cz2__oos-icon {
        width: 175px;
        height: 175px;

        margin-left: auto;
        margin-right: auto;

        margin-top: 25px;

        background: transparent url(../assets/icons/alert.svg) no-repeat center/contain;
    }
</style>

<script>
    import AlertModal from './ui/AlertModal.vue';

    export default {
        components: {
            AlertModal,
        },

        computed: {
            isTemporarilyOutOfStock() {
                return this.$store.isTemporarilyOutOfStock;
            },

            title() {
                return this.isTemporarilyOutOfStock ? this.$t('TOOS') : this.$t('OOS_WARNING_TITLE');
            },

            bodyCopy() {
                return this.isTemporarilyOutOfStock ? this.$t('TOOS_WARNING_BODY') : this.$t('OOS_WARNING_BODY');
            },
        },

        methods: {
            close() {
                this.$store.dispatch('showOutOfStockWarning', null);
                this.$store.isTemporarilyOutOfStock = false;
            },
        },
    };
</script>
